import styled from 'styled-components';
import { TextStyle } from 'components/text';

export const AutomaticFlowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const AutomaticFlowContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 35px;
  margin-top: 16px;
`;

export const BackButton = styled.button`
  align-self: flex-start;
  background: none;
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 28px;

  input[type='number'] {
    appearance: textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }
  }
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.neutral_500};
  font-weight: 300;
  font-size: 12px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 10px;
  min-width: 280px;

  ${TextStyle} {
    max-width: 300px;
  }
`;

export const InvoiceWrapper = styled.div`
  display: flex;
  gap: 8px;

  & > :first-child {
    min-width: 156px;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
`;
